import { default as classnames, default as cn } from 'classnames';
import moment from 'moment';
import { useEffect, useState } from 'react';
import ReactStars from 'react-rating-stars-component';
import ImageViewer from 'react-simple-image-viewer';
import lock_icon from '../../../../../assets/media/icons/free-icon-lock-93140.svg';
import unlock_icon from '../../../../../assets/media/icons/free-icon-open-lock-93144.svg';
import okay3 from '../../../../../assets/media/icons/okay10.svg';
import { MARKET_MODES } from '../../../../../constans';
import ProfitBlock from '../../../../../pages/Shipments/Supply/SupplyItemLine/ProfitBlock';
import { formFullDate, numberWithSpaces } from '../../../../../utils';
import { Column, Row } from '../../../../Basic/Blocks';
import { Button, ButtonWithTooltip, CheckButton } from '../../../../Basic/Buttons';
import { Icon, Link } from '../../../../Basic/Elements';
import { Input } from '../../../../Basic/Inputs';
import { TableCell, TableLine } from '../../../../Basic/Table';
import { Text, TextGrey } from '../../../../Basic/WrapsStyle';
import ProviderList from '../../../../Common/Input/ProviderList';
import PackagingMethodSelect from '../../../../Providers/Inputs/PackagingMethodSelect';
import PostingStatusWrap from '../../../../Shipments/WrapStyle/PostingStatus';
import CommissionNdsBlock from '../../CommissionNdsBlock';
import CommissionWbBlock from '../../CommissionWbBlock';
import styles from './styles.module.scss';

export const GO_TO_WB = (id) => `https://www.wildberries.ru/catalog/${id}/detail.aspx?targetUrl=SP`;

const parseErrorsData = (error) => {
  console.log(error);
  if (error?.type === 'high_diff_price') {
    return `, новая цена - ${error?.data?.new_price}`;
  }
  if (error?.data?.badFields?.length > 0) {
    return ` (${error.data.badFields.join(', ')}) .`;
  }
  return '';
};

const WIDTH_MARKETPLACE = [
  '110px', //0
  '160px', //1
  '400px', //2
  '100px', //3
  '100px', //4
  '60px', //5
  '150px', //6
  '160px', //7
  '200px', //8
  '150px', //9
  '40px', //10
  '170px', //11
  '120px', //12
  '70px', //13
  '30px', //14
];

const MarketsLine = ({
  pricesMode,
  packageMethods,
  sizesMode,
  item = {},
  isOwner = false,
  isExpress = false,
  onChangeProduct = (_) => _,
  printSticker = (_) => _,
  selectTab,
  productsSelect = {},
  changeProductSelect = (_) => _,
  market = '',
  shop = '',
  contentMode,
}) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [images, setImages] = useState([]);

  let [card, setCard] = useState(item);
  const [isOpenPostingsArray, setIsOpenPostingsArray] = useState(false);

  const openImageViewer = (imgs) => {
    setImages(imgs);
    setIsViewerOpen(true);
  };

  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };

  let onChange = (key, value, skladName) => {
    if (card[key] === value) {
      return;
    }
    onChangeProduct(card.offer_id, key, value, skladName);
  };

  useEffect(() => {
    setCard(item);
  }, [item, shop]);

  return (
    <>
      <TableLine key={card.offer_id} select={productsSelect[card.offer_id]} isError={card.errors_array?.length > 0}>
        <TableCell width={WIDTH_MARKETPLACE[4]}>
          <Row spaceBetween={true}>
            <CheckButton checked={productsSelect[card.offer_id]} onSelect={() => changeProductSelect(card.offer_id)} />
            <div className={styles.wrapper}>
              <img
                onClick={() => openImageViewer(card.images)}
                className={styles.preview}
                src={(card.images || []).length > 0 ? card.images[0] : undefined}
              />
              {/* {card.stock.mp?.warehouse > 0 && <p className={cn(styles.warehouse)}>Склад вб</p>} */}
            </div>
            {/* <BarcodePopUp
              card={card}
              onPrint={printSticker}
            /> */}
          </Row>
        </TableCell>
        {/* <TableCell width={WIDTH_MARKETPLACE[8]} minWidth={WIDTH_MARKETPLACE[8]} center={true}> */}

        {/* </TableCell> */}
        <TableCell width={WIDTH_MARKETPLACE[1]}>
          {card.offer_id}
          {market === 'WB' && (
            <Row style={{ width: '100%' }}>
              <Link
                blue={true}
                href={GO_TO_WB(card.nmID)}
                style={{ width: 'auto', fontSize: '10px', userSelect: 'auto' }}
                target={'_blank'}
              >
                {card.nmID}
              </Link>
              {card.stock.mp?.warehouse > 0 && <p className={cn(styles.warehouse)}>Склад вб</p>}
              {/* {card.warehouse_wb.in_way_to_client > 0 && card.stock.wb_warehouse === 0 && (
                <p className={cn(styles.warehouse)}>В пути к клиенту</p>
              )}
              {card.warehouse_wb.in_way_from_client > 0 &&
                card.warehouse_wb.in_way_to_client === 0 &&
                card.stock.warehouse === 0 && <p className={cn(styles.warehouse)}>В пути от клиента</p>} */}
            </Row>
          )}
          {/*    {card.price !== card.marketing_price && <div className={cn(styles.sale)}>Акция</div>}*/}
        </TableCell>
        {contentMode !== MARKET_MODES[3] && <TableCell width={WIDTH_MARKETPLACE[12]}>{card.brand}</TableCell>}
        <TableCell width={WIDTH_MARKETPLACE[2]} style={{ flexWrap: 'nowrap' }}>
          <Column>
            <p className={styles.name_text}>{card.name}</p>
            <TextGrey fontSize={12}>{card.category}</TextGrey>
          </Column>
        </TableCell>

        {selectTab === 'error' && (
          <TableCell width={WIDTH_MARKETPLACE[2]}>
            <Text style={{ color: 'red' }}>
              {card.errors_array?.length > 0 &&
                card.errors_array.map((e) => `${e?.message}${parseErrorsData(e)} `).join('; ')}
            </Text>
          </TableCell>
        )}
        {selectTab === 'warning' && (
          <TableCell width={WIDTH_MARKETPLACE[2]}>
            <Text style={{ color: 'red' }}>
              {card.warnings_array?.length > 0 && card.warnings_array.map((m) => m?.message).join('; ')}
            </Text>
          </TableCell>
        )}

        {[MARKET_MODES[0], MARKET_MODES[3]].includes(contentMode) && (
          <>
            {contentMode === MARKET_MODES[3] && (
              <TableCell width={WIDTH_MARKETPLACE[4]} center>
                <div style={{ fontSize: '18px', minWidth: 'fit-content' }}>{card?.stock?.msk?.summary || 0}</div>
              </TableCell>
            )}
            <TableCell width={WIDTH_MARKETPLACE[4]} center>
              <Row>
                <Input value={card?.stock?.msk?.common || 0} center onBlur={(v) => onChange('stock', v, 'msk')} />
                {(card?.stock?.msk?.to_add || 0) !== 0 && (
                  <div style={{ minWidth: 'fit-content' }}> + {card?.stock?.msk?.to_add}</div>
                )}
              </Row>
            </TableCell>
            {/* <TableCell width={WIDTH_MARKETPLACE[3]} center>
              <Input value={card?.stock?.ekb?.common || 0} center onBlur={(v) => onChange('stock', v, 'ekb')} />
            </TableCell> */}
            {selectTab === 'warehouse' && (
              <TableCell width={WIDTH_MARKETPLACE[3]} center>
                <Input value={card.stock?.msk?.warehouse} center readOnly />
              </TableCell>
            )}
            {selectTab === 'warehouse' && (
              <TableCell width={WIDTH_MARKETPLACE[3]} center>
                <Input value={card.stock?.ekb?.warehouse} center readOnly />
              </TableCell>
            )}
            {selectTab === 'mpwarehouse' && (
              <TableCell width={WIDTH_MARKETPLACE[3]} center>
                <Input value={card.stock?.mp?.common} center readOnly />
              </TableCell>
            )}
            {isExpress && (
              <TableCell width={WIDTH_MARKETPLACE[3]} center>
                <Input value={card.stock?.msk?.express + card.stock?.ekb?.express} center readOnly />
              </TableCell>
            )}
          </>
        )}
        {contentMode === MARKET_MODES[3] && (
          <>
            <TableCell width={WIDTH_MARKETPLACE[8]} center={true}>
              <ButtonWithTooltip
                style={{
                  ...(card.postings?.length === 0 && { opacity: '40%' }),
                  fontSize: '22px',
                  fontWeight: 600,
                }}
                // disabled={product.postings.length === 0}
                tooltip={isOpenPostingsArray ? 'Скрыть список заказов' : 'Показать список заказов'}
                onClick={() => setIsOpenPostingsArray(!isOpenPostingsArray)}
              >
                <Column style={{ alignItems: 'center' }}>
                  <Row>
                    {card.total?.total.count === 0 ? (
                      <span style={{ color: '#2d2e2dab' }}>{card.total?.sold.count}</span>
                    ) : (
                      <>
                        {card.total?.delivery.count > 0 && (
                          <span style={{ color: '#807e01ab' }}>{card.total?.delivery.count}</span>
                        )}
                        {card.total?.delivery.count > 0 && card.total?.sold.count > 0 && <span> / </span>}
                        {card.total?.sold.count > 0 && (
                          <span style={{ color: '#01800eab' }}>{card.total?.sold.count}</span>
                        )}
                        {card.total?.sold.count + card.total?.delivery.count > 0 && card.total?.cancel.count > 0 && (
                          <span> / </span>
                        )}
                        {card.total?.cancel.count > 0 && (
                          <span style={{ color: '#ff00006e' }}>{card.total?.cancel.count}</span>
                        )}
                        {card.total?.cancel.count + card.total?.sold.count + card.total?.delivery.count > 0 &&
                          card.total?.cancel.return_pvz_count > 0 && <span> / </span>}
                        {card.total?.cancel.return_pvz_count > 0 && (
                          <span style={{ color: '#870000a5' }}>{card.total?.cancel.return_pvz_count}</span>
                        )}
                        {/* {(card.total?.cancel.count + card.total?.sold.count + card.total?.delivery.count + card.total?.cancel.return_pvz_count) > 0 && (<span> / </span>)} */}
                        {/* {product.processed_quantity} */}
                        {/* <span style={{ color: '#637108ff' }}>{product.all_count}</span> /  */}
                      </>
                    )}
                    {/* <span style={{ color: '#00000065', fontSize: '17px' }}> ({Object.keys(_.groupBy(card.postings, 'group_number')).length})</span> */}
                  </Row>
                  {card.last_order_date && (
                    <Row style={{ color: '#00000065', fontSize: '12px' }}>
                      {moment(card.last_order_date).format('DD-MM-YYYY HH:mm')}
                    </Row>
                  )}
                </Column>
              </ButtonWithTooltip>
            </TableCell>
            {isOwner && (
              <TableCell width={WIDTH_MARKETPLACE[6]} center>
                <ProfitBlock
                  profit={{
                    total: card.total?.total.profit,
                    total_by_report: card.total_report?.total.profit,

                    return_pvz: -card.total?.cancel.return_pvz,
                    cancel: card.total?.cancel.profit,

                    cancel_by_report: card.total_report?.cancel.profit,

                    sold: card.total?.sold.profit,
                    sold_by_report: card.total_report?.sold.profit,

                    return_blocked: card.total_return_blocked || 0,

                    potential_sale: {
                      count: card.processed_quantity - card.total?.sold.count - card.total?.cancel.return_pvz_count,
                      profit: card.profit?.rub,
                    },
                  }}
                />
              </TableCell>
            )}
            {pricesMode && (
              <>
                <TableCell width={WIDTH_MARKETPLACE[4]} center={true}>
                  <Column style={{ alignItems: 'center' }}>
                    <div style={{ fontSize: '16px' }}>{card.prices?.price}</div>
                    {card.errors_array.find((e) => e.type === 'high_diff_price') && (
                      <div style={{ color: '#d11616ce', marginTop: '5px' }}>
                        {card.errors_array.find((e) => e.type === 'high_diff_price')?.data?.new_price}
                      </div>
                    )}
                  </Column>
                </TableCell>
                <TableCell width={WIDTH_MARKETPLACE[4]} center={true}>
                  <Column style={{ alignItems: 'center' }}>
                    <Input
                      style={{ marginBottom: '5px' }}
                      value={card.purchase}
                      center
                      onBlur={(v) => onChange('purchase', v)}
                      // onChange={(v) => changeProductsInSupply({ action: 'change_term', id: product._id, value: new Date(v) })}
                    />
                    {card.quantity > 1 && (
                      <div style={{ color: '#0000006d', fontSize: '15px' }}>
                        {+(card.purchase * card.quantity).toFixed(2)}
                      </div>
                    )}
                  </Column>
                </TableCell>
                <TableCell
                  width={WIDTH_MARKETPLACE[6]}
                  // style={{ flexDirection: 'row' }}
                  center
                >
                  <Row>
                    <Column style={{ width: 'fit-content' }}>
                      <Text className={cn(card.profit?.is_minus && styles.red_text)}>
                        {Number.isFinite(card.profit?.percent) ? Math.ceil(card.profit?.percent) : '-'} %
                      </Text>
                    </Column>
                    <div style={{ marginLeft: '15px' }}>
                      <Text fontWeight={600} className={card.profit?.is_minus ? styles.red_text : styles.green_text}>
                        {Number.isFinite(card.profit?.percent) ? numberWithSpaces(Math.ceil(card.profit?.rub)) : '-'}
                      </Text>
                      <CommissionNdsBlock card={card} market={market} />
                    </div>
                    <div
                      style={{
                        marginLeft: '10px',
                        backgroundColor: '#6d2d7052',
                        borderRadius: '25px',
                        padding: '4px 4px',
                        color: '#000000a1',
                        fontSize: '10px',
                        fontWeight: 'bold',
                      }}
                    >
                      {card.sale_schema?.toUpperCase()}
                    </div>
                  </Row>
                </TableCell>
                <TableCell width={WIDTH_MARKETPLACE[13]} center>
                  <Input
                    bold={card.marginality?.is_fixed}
                    value={card.marginality?.percent}
                    center
                    onBlur={(v) => onChange('percent', v)}
                  />
                </TableCell>
                <TableCell width={WIDTH_MARKETPLACE[13]} center>
                  <Input
                    bold={card.marginality?.is_fixed}
                    value={card.marginality?.min_rub}
                    onBlur={(v) => onChange('min_rub', v)}
                    center
                  />
                </TableCell>
                <TableCell width={WIDTH_MARKETPLACE[14]}>
                  <Button
                    style={{ marginLeft: '-10px' }}
                    onClick={() => onChange('fixed_marginality', !card.marginality.is_fixed)}
                  >
                    <Icon style={{}} src={card.marginality?.is_fixed ? lock_icon : unlock_icon} width={20} />
                  </Button>
                </TableCell>
              </>
            )}

            {/* <TableCell width={WIDTH_MARKETPLACE[7]} center={true}>

              <ButtonWithTooltip
                style={{
                  ...(product.postings?.length === 0 && { opacity: '40%' }),
                  fontSize: '22px', 'fontWeight': 600,
                }}
                // disabled={product.postings.length === 0}
                tooltip={isOpenPostingsArray ? 'Скрыть список заказов' : 'Показать список заказов'}
                onClick={() => setIsOpenPostingsArray(!isOpenPostingsArray)}
              >
                <Column style={{ alignItems: 'center' }}>
                  <Row >
                    {card.total?.sold.count === product.ordered_quantity && card.total?.cancel.count === 0 ? (
                      <span style={{ color: '#01800eab' }}>{card.total?.sold.count}</span>
                    ) : (
                      <>
                        {card.total?.delivery.count > 0 && (<span style={{ color: '#807e01ab' }}>{card.total?.delivery.count}</span>)}
                        {(card.total?.delivery.count > 0 && card.total?.sold.count > 0) && (<span> / </span>)}
                        {card.total?.sold.count > 0 && (<span style={{ color: '#01800eab' }}>{card.total?.sold.count}</span>)}
                        {((card.total?.sold.count + card.total?.delivery.count) > 0 && card.total?.cancel.count > 0) && (<span> / </span>)}
                        {card.total?.cancel.count > 0 && (<span style={{ color: '#ff00006e' }}>{card.total?.cancel.count}</span>)}
                        {((card.total?.cancel.count + card.total?.sold.count + card.total?.delivery.count) > 0 && card.total?.cancel.return_pvz_count > 0) && (<span> / </span>)}
                        {card.total?.cancel.return_pvz_count > 0 && (<span style={{ color: '#870000a5' }}>{card.total?.cancel.return_pvz_count}</span>)}
                        {(card.total?.cancel.count + card.total?.sold.count + card.total?.delivery.count + card.total?.cancel.return_pvz_count) > 0 && (<span> / </span>)}
                        {product.processed_quantity}
                      </>
                    )}
                    <span style={{ color: '#00000065', fontSize: '17px' }}> ({Object.keys(_.groupBy(product.postings, 'group_number')).length})</span>
                  </Row>
                  {product.last_order_date &&
                    <Row style={{ color: '#00000065', fontSize: '12px' }}>
                      {moment(product.last_order_date).format('DD-MM-YYYY HH:mm')}
                    </Row>
                  }
                </Column>
              </ButtonWithTooltip>
            </TableCell> */}
          </>
        )}

        {(contentMode === MARKET_MODES[0] || contentMode === MARKET_MODES[1]) && (
          <>
            {market === 'WB' && (
              <>
                <TableCell width={WIDTH_MARKETPLACE[7]} center>
                  <Row>
                    <Text style={{ width: '70px' }}>{card.prices?.price}</Text> /{' '}
                    <Input value={card?.prices?.old_price} width={'70px'} center onBlur={(v) => onChange('price', v)} />
                  </Row>
                </TableCell>
              </>
            )}
            {(market === 'MM' || market === 'OZON') && (
              <>
                <TableCell width={WIDTH_MARKETPLACE[7]} center>
                  <Row>
                    <Input value={card?.prices?.price} width={'70px'} center onBlur={(v) => onChange('price', v)} /> /{' '}
                    <Text style={{ width: '70px' }}>{card.prices?.old_price}</Text>
                  </Row>
                </TableCell>
              </>
            )}
            {market === 'KUPER' && (
              <>
                <TableCell width={WIDTH_MARKETPLACE[4]} center>
                  <Row>
                    <Input value={card?.prices?.price} width={'70px'} center onBlur={(v) => onChange('price', v)} />
                  </Row>
                </TableCell>
              </>
            )}
            {market === 'YANDEX' && (
              <>
                <TableCell width={WIDTH_MARKETPLACE[7]} center>
                  <Row>
                    <Input
                      value={card.prices.price}
                      center
                      onBlur={(v) => onChange('price', v)}
                      style={{ marginRight: '10px' }}
                    />

                    <TextGrey className={styles.all_price}>
                      {' '}
                      {(card.prices?.price * card.min_quantity).toFixed(2)}
                    </TextGrey>
                  </Row>
                </TableCell>
              </>
            )}

            {isOwner && (
              <>
                <TableCell width={WIDTH_MARKETPLACE[4]} center>
                  <Input value={card.purchase} center onBlur={(v) => onChange('purchase', v)} />
                </TableCell>
                {market === 'WB' && (
                  <TableCell width={WIDTH_MARKETPLACE[4]} center>
                    <Input value={card.discount.percent} center onBlur={(v) => onChange('discount', v)} />
                  </TableCell>
                )}
                {contentMode === MARKET_MODES[1] && (
                  <>
                    <TableCell width={WIDTH_MARKETPLACE[4]} center>
                      <Input value={card.marginality?.percent} center onBlur={(v) => onChange('percent', v)} />
                    </TableCell>
                    <TableCell width={WIDTH_MARKETPLACE[4]} center>
                      <Input value={card.marginality?.min_rub} center onBlur={(v) => onChange('min_rub', v)} />
                    </TableCell>
                  </>
                )}

                <TableCell
                  width={WIDTH_MARKETPLACE[6]}
                  style={{
                    flexDirection: 'row',
                  }}
                  center
                >
                  <Text className={classnames(styles.block_mar, card.profit?.is_minus && styles.red_text)}>
                    {card.profit?.percent ? Math.ceil(card.profit?.percent) : '-'} %
                  </Text>
                  <div className={styles.block_commission}>
                    <Text fontWeight={600} className={card.profit?.is_minus ? styles.red_text : styles.green_text}>
                      {card.profit?.percent ? numberWithSpaces(Math.ceil(card.profit?.rub)) : '-'}
                    </Text>
                    <CommissionNdsBlock card={card} market={market} />
                  </div>
                </TableCell>

                {isOwner && isExpress && market !== 'WB' && (
                  <TableCell
                    width={WIDTH_MARKETPLACE[6]}
                    style={{
                      flexDirection: 'row',
                    }}
                    center
                  >
                    <Text className={classnames(styles.block_mar, card.profit?.is_minus_express && styles.red_text)}>
                      {card.profit?.express_percent ? Math.ceil(card.profit?.express_percent) : '-'} %
                    </Text>
                    <div className={styles.block_commission}>
                      <Text
                        fontWeight={600}
                        className={card.profit?.is_minus_express ? styles.red_text : styles.green_text}
                      >
                        {card.profit?.express_percent ? numberWithSpaces(Math.ceil(card.profit?.express_rub)) : '-'}
                      </Text>
                      <CommissionNdsBlock card={card} market={market} isExpress={true} />
                    </div>
                  </TableCell>
                )}
                {contentMode === MARKET_MODES[1] && (
                  <>
                    <TableCell width={WIDTH_MARKETPLACE[4]} center>
                      <Input value={card.nds} center onBlur={(v) => onChange('nds', v)} />
                    </TableCell>
                  </>
                )}
              </>
            )}
          </>
        )}

        {contentMode === MARKET_MODES[2] ||
          (sizesMode && (
            <>
              <TableCell width={WIDTH_MARKETPLACE[8]} center>
                <PackagingMethodSelect
                  method={packageMethods.find((m) => m._id === card?.packaging_method_id)?.method}
                  // disabled={!is_owner}
                  onSelect={(v) => onChange('packaging_method', v._id)}
                />
              </TableCell>
              <TableCell width={WIDTH_MARKETPLACE[4]} center>
                <Input value={card.sizes_package.width} center onBlur={(v) => onChange('width', v)} />
              </TableCell>
              <TableCell width={WIDTH_MARKETPLACE[4]} center>
                <Input value={card.sizes_package.height} center onBlur={(v) => onChange('height', v)} />
              </TableCell>
              <TableCell width={WIDTH_MARKETPLACE[4]} center>
                <Input value={card.sizes_package.depth} center onBlur={(v) => onChange('depth', v)} />
              </TableCell>
              {market !== 'WB' && (
                <TableCell width={WIDTH_MARKETPLACE[4]} center>
                  <Input value={card.sizes_package.weight} center onBlur={(v) => onChange('weight', v)} />
                </TableCell>
              )}

              {/* {market === 'YANDEX' ? (
              <>
                <TableCell width={WIDTH_MARKETPLACE[4]} center>
                  {card.volume_weight}
                </TableCell>
                <TableCell width={WIDTH_MARKETPLACE[4]} center>
                  {(card.sizes_package.weight * card.min_quantity).toFixed(2)}
                </TableCell>
              </>
            ) : (
              <> */}
            <TableCell width={WIDTH_MARKETPLACE[4]} center>
              {card.sizes_package.volume}
            </TableCell>
            {/* </> */}
            {/* )} */}

              {!sizesMode && (
                <>
                  <TableCell width={WIDTH_MARKETPLACE[4]} center>
                    <Text fontWeight={600}>
                      {market === 'WB' ? card.commission?.delivery?.rub : card.commission?.delivery_sort_center?.rub} ₽
                    </Text>
                  </TableCell>
                  <TableCell
                    width={WIDTH_MARKETPLACE[6]}
                    style={{
                      flexDirection: 'row',
                    }}
                    center
                  >
                    <Text className={classnames(styles.block_mar, card.profit?.is_minus && styles.red_text)}>
                      {card.profit?.percent ? Math.ceil(card.profit?.percent) : '-'} %
                    </Text>
                    <div className={styles.block_commission}>
                      <Text fontWeight={600} className={card.profit?.is_minus ? styles.red_text : styles.green_text}>
                        {card.profit?.percent ? numberWithSpaces(Math.ceil(card.profit?.rub)) : '-'}
                      </Text>
                      <CommissionNdsBlock card={card} market={market} />
                    </div>
                  </TableCell>
                </>
              )}
            </>
          ))}

        {/* {market === 'YANDEX' && (
          <TableCell width={WIDTH_MARKETPLACE[4]} center>
            <Input value={card.min_quantity} center onBlur={(v) => onChange(card, 'min_quantity', v)} />
          </TableCell>
        )} */}
        {contentMode !== MARKET_MODES[3] && (
          <TableCell width={WIDTH_MARKETPLACE[4]} center>
            <Column style={{ alignItems: 'center' }} center={true}>
              <Text fontWeight={card.sale_statistic?.num_sales > 0 ? 600 : 400}>{card.sale_statistic?.num_sales}</Text>
              {card.sale_statistic?.date_last_sale && (
                <TextGrey style={{ textAlign: 'center', fontSize: '12px' }}>
                  {moment(card.sale_statistic?.date_last_sale).fromNow()}
                </TextGrey>
              )}
            </Column>
          </TableCell>
        )}
        <TableCell width={WIDTH_MARKETPLACE[11]} center>
          <ProviderList
            selectProviderId={card.provider_id}
            // disabled={!isOwner}
            onSelect={(v) => onChange('provider_id', v.id)}
          />
        </TableCell>
        <TableCell width={WIDTH_MARKETPLACE[7]} center>
          <Input value={card.provider_artnumber} onBlur={(v) => onChange('provider_artnumber', v)} />
        </TableCell>
        <TableCell width={WIDTH_MARKETPLACE[4]} center>
          <Input value={card.quantity} disabled={!isOwner} center onBlur={(v) => onChange('quantity', v)} />
        </TableCell>
        {contentMode !== MARKET_MODES[3] && (
          <TableCell width={WIDTH_MARKETPLACE[7]} center>
            <Input value={card.warehouse_id} disabled={!isOwner} onBlur={(v) => onChange('warehouse_id', v)} />
          </TableCell>
        )}
        {isOwner && contentMode !== MARKET_MODES[3] && (
          <>
            <TableCell width={WIDTH_MARKETPLACE[0]} style={{ justifyContent: 'flex-end' }}>
              <Row>
                <Button onClick={() => onChange('stopbrand', !card.status_flags.is_stop_brand)}>
                  <Icon src={card.status_flags?.is_stop_brand ? lock_icon : unlock_icon} width={25} />
                </Button>
              </Row>
            </TableCell>

            <TableCell width={WIDTH_MARKETPLACE[9]} className={styles.cell_date}>
              {card.updated_at ? (
                <>
                  <Text>{formFullDate(card.updated_at)}</Text>
                  <TextGrey fontSize={12}> {moment(card.updated_at).fromNow()}</TextGrey>
                </>
              ) : (
                '-'
              )}
            </TableCell>
          </>
        )}
        {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
      </TableLine>
      {isOpenPostingsArray && (
        <Column style={{}} className={styles.history_block}>
          {/* <Column style={{overflowY: 'scroll',  maxHeight: '1000px'}} className={styles.history_block}> */}
          {_.sortBy(card.postings, 'dates.created_at', 'sticker_parts.full')
            .map((p, i) => {
              return {
                ...p,
                next_posting_number: _.sortBy(card.postings, 'dates.created_at')
                  .slice(i + 1)
                  .find(
                    (pp) =>
                      pp.posting_number !== p.posting_number &&
                      p.sticker_parts?.initial &&
                      pp.sticker_parts?.initial === p.sticker_parts?.initial,
                  )?.posting_number,
                // next_posting_number_is_group: product.postings.slice(i + 1).find(pp => pp.posting_number !== p.posting_number && p.group_number && (pp.group_number === p.group_number))
              };
            })
            .map((posting, i) => (
              <Column>
                <Row key={posting.posting_number}>
                  <div style={{ color: '#00000078', fontWeight: 'bold', minWidth: '20px' }}>{i + 1}</div>
                  <div
                    style={{
                      margin: '0 15px',
                      borderRight: '2px solid #00000046',
                      display: 'flex',
                      alignSelf: 'stretch',
                    }}
                  ></div>

                  <Column style={{ minWidth: '330px' }}>
                    <TextGrey style={{ color: '#0000007f' }}>
                      Дата заказа:{' '}
                      <span style={{ color: '#000000ff' }}>
                        {moment(posting.dates.created_at).format('DD.MM.YYYY')}{' '}
                      </span>{' '}
                      <span style={{ fontSize: '13px', color: '#000000ad', marginTop: '4px' }}>
                        {moment(posting.dates.created_at).format('HH:mm')}{' '}
                      </span>
                    </TextGrey>
                    {market === 'WB' && (
                      <TextGrey style={{ color: '#0000007f' }}>
                        Стикер:{' '}
                        <span style={{ color: '#000000ff' }}>
                          {' '}
                          {posting.sticker_parts?.full} / {posting.sticker_parts?.initial}{' '}
                        </span>
                      </TextGrey>
                    )}
                    <span style={{ fontSize: '12px', color: '#0000007f' }}>
                      Номер заказа: <span style={{ color: '#000000b3' }}> {posting.posting_number} </span>
                    </span>
                    {market === 'WB' && (
                      <span style={{ fontSize: '12px', color: '#0000007f' }}>
                        id корзины: <span style={{ color: '#000000b3' }}> {posting.group_number} </span>
                      </span>
                    )}
                  </Column>
                  <div
                    style={{
                      margin: '0 15px',
                      borderRight: '2px solid #00000046',
                      display: 'flex',
                      alignSelf: 'stretch',
                    }}
                  ></div>
                  <Column style={{ minWidth: '210px' }}>
                    <div style={{ alignSelf: 'center', margin: '0px 0 10px' }}>
                      <PostingStatusWrap order={posting}></PostingStatusWrap>
                    </div>
                    {(posting.products[0]?.commission?.increased_commission?.from_report ||
                      posting.products[0]?.commission?.returns?.from_report) && (
                      <div style={{ position: 'relative' }}>
                        <img
                          src={okay3}
                          style={{ position: 'absolute', left: '169px', bottom: '0px', width: '22px' }}
                        />
                      </div>
                    )}
                    {posting.dates.sold_at && (
                      <TextGrey style={{ color: '#0000007f' }}>
                        Дата продажи: <span style={{ color: '#000000ff' }}> {getDate(posting.dates.sold_at)} </span>
                      </TextGrey>
                    )}
                    {posting.dates.canceled_at && (
                      <TextGrey style={{ color: '#0000007f' }}>
                        Дата отмены: <span style={{ color: '#000000ff' }}> {getDate(posting.dates.canceled_at)} </span>
                      </TextGrey>
                    )}
                  </Column>
                  {isOwner && (
                    <>
                      <div
                        style={{
                          margin: '0 15px',
                          borderRight: '2px solid #00000046',
                          display: 'flex',
                          alignSelf: 'stretch',
                        }}
                      ></div>
                      <Row style={{ minWidth: '240px' }}>
                        <Column>
                          <TextGrey style={{ color: '#0000007f' }}>
                            Цена закупки:
                            <div style={{ color: '#000000ff' }}>
                              {' '}
                              {+(posting.products[0].purchase * posting.products[0].common_quantity).toFixed()}
                            </div>
                          </TextGrey>
                          {['Ожидает отгрузки', 'Продано', 'Прибыл на ПВЗ', 'Доставляется'].includes(
                            posting.status,
                          ) && (
                            <TextGrey style={{ color: '#0000007f' }}>
                              Марж.:
                              <div style={{ color: '#000000ff' }}>
                                {' '}
                                {+posting.products[0]?.profit?.percent?.toFixed(0)} %
                              </div>
                            </TextGrey>
                          )}
                        </Column>
                        <Column style={{ alignItems: 'flex-end', width: 'max-content' }}>
                          <div
                            style={{
                              fontWeight: 'bold',
                              color: posting.products[0]?.profit?.rub > 0 ? 'green' : 'red',
                            }}
                          >
                            {posting.products[0]?.profit?.rub}
                          </div>
                          <div style={{ marginLeft: '10px', width: 'max-content' }} className={styles.block_commission}>
                            <CommissionWbBlock
                              market={market.toLowerCase()}
                              commission={posting.products[0]?.commission}
                            />
                          </div>
                        </Column>
                      </Row>
                      <div
                        style={{
                          margin: '0 15px',
                          borderRight: '2px solid #00000046',
                          display: 'flex',
                          alignSelf: 'stretch',
                        }}
                      ></div>
                      <Column style={{ minWidth: '250px' }}>
                        <TextGrey style={{ color: '#0000007f' }}>
                          Цена продажи:<span style={{ color: '#000000ff' }}> {posting.products[0].price} руб.</span>{' '}
                          {posting.products[0].price_report &&
                            posting.products[0].price_report !== posting.products[0].price && (
                              <span style={{ color: '#e11515ff' }}> / {posting.products[0].price_report}</span>
                            )}{' '}
                          {market !== 'WB' && ` x ${posting.products[0].ordered_quantity} шт.`}{' '}
                        </TextGrey>
                        {posting.products[0].price_final && (
                          <TextGrey style={{ color: '#0000007f' }}>
                            Цена продажи (фин):
                            <span style={{ color: '#000000ff' }}> {posting.products[0].price_final} руб.</span>{' '}
                          </TextGrey>
                        )}
                      </Column>
                    </>
                  )}

                  {/* <div style={{ margin: '0 15px', borderRight: '2px solid #00000046', display: 'flex', alignSelf: 'stretch' }}></div>
                  <Row center style={{ minWidth: '100px' }}>
                    <Text className={classNames(data.profit?.is_minus && styles.red_text)}>
                      {Number.isFinite(data.profit?.percent) ? Math.ceil(data.profit?.percent) : '-'} %
                    </Text>

                    <div className={styles.block_commission}>
                      <Text fontWeight={600} className={data.profit?.is_minus ? styles.red_text : styles.green_text}>
                        {Number.isFinite(data.profit?.percent) ? numberWithSpaces(Math.ceil(data.profit?.rub)) : '-'}
                      </Text>
                      <CommissionNdsBlock card={data} market={'WB'} />
                    </div>


                  </Row> */}

                  <div
                    style={{
                      margin: '0 15px',
                      borderRight: '2px solid #00000046',
                      display: 'flex',
                      alignSelf: 'stretch',
                    }}
                  ></div>

                  {(posting.review?.id || posting.way?.to) && (
                    <>
                      <Column style={{ minWidth: 'max-content' }}>
                        {posting.review.rating && (
                          <div style={{ width: 'max-content' }}>
                            <ReactStars
                              size={16}
                              value={posting.review.rating}
                              activeColor={'rgb(255 56 5'}
                              edit={false}
                            />
                          </div>
                        )}
                        {posting.review?.comment && (
                          <TextGrey style={{ color: '#0000007f', width: 'max-content', maxWidth: '900px' }}>
                            {posting.review.customer}:
                            <div style={{ color: '#000000ff' }}> {posting.review?.comment}</div>{' '}
                          </TextGrey>
                        )}
                        {posting.review?.pros && (
                          <TextGrey style={{ color: '#0000007f', width: 'max-content', maxWidth: '900px' }}>
                            Достоинства:
                            <div style={{ width: 'max-content', color: '#000000ff' }}> {posting.review?.pros}</div>{' '}
                          </TextGrey>
                        )}
                        {posting.review?.cons && (
                          <TextGrey style={{ color: '#0000007f', width: 'max-content', maxWidth: '900px' }}>
                            Недостатки:
                            <div style={{ width: 'max-content', color: '#000000ff' }}> {posting.review?.cons}</div>{' '}
                          </TextGrey>
                        )}
                        {posting.way?.to && (
                          <span style={{ fontSize: '14px', color: '#0000007f' }}>
                            Регион: <span style={{ fontSize: '16px', color: '#000000e1' }}>{posting.way?.to}</span>
                          </span>
                        )}
                        {posting.way?.to && (
                          <span style={{ fontSize: '14px', color: '#0000007f' }}>
                            Округ: <span style={{ fontSize: '16px', color: '#000000e1' }}>{posting.way?.to_okrug}</span>
                          </span>
                        )}
                      </Column>
                    </>
                  )}
                  {posting.next_posting_number && (
                    <>
                      <div
                        style={{
                          margin: '0 15px',
                          borderRight: '2px solid #00000046',
                          display: 'flex',
                          alignSelf: 'stretch',
                        }}
                      ></div>
                      <Row style={{ minWidth: '220px' }}>
                        {posting.next_posting_number && (
                          <div>
                            {'-> '}
                            {_.sortBy(card.postings, 'dates.created_at', 'sticker_parts.full').findIndex(
                              (p) => p.posting_number === posting.next_posting_number,
                            ) + 1}{' '}
                            (
                            {
                              card.postings?.filter((p) => p.sticker_parts?.initial === posting.sticker_parts?.initial)
                                .length
                            }
                            )
                          </div>
                        )}
                      </Row>
                    </>
                  )}
                </Row>
                {posting.next_posting_number_is_group ? (
                  <hr style={{ width: '100%' }}></hr>
                ) : (
                  <hr style={{ width: '100%' }}></hr>
                )}
              </Column>
            ))}
        </Column>
      )}
    </>
  );
};

export default MarketsLine;
